import {
  Archive,
  BadgeCheck,
  Ban,
  CalendarClock,
  Check,
  CheckCheck,
  CopyCheck,
  CircleCheck,
  CircleHelp,
  CirclePlus,
  CircleSlash,
  CircleX,
  Eye,
  FileClock,
  FilePen,
  FileText,
  FileX,
  Flag,
  Hourglass,
  Inbox,
  Info,
  Layers,
  Link,
  ListOrdered,
  ListPlus,
  LoaderCircle,
  LogOut,
  MessageCircle,
  MessageCircleReply,
  Pause,
  RotateCw,
  Send,
  ShieldCheck,
  ShieldX,
  SlidersHorizontal,
  SkipForward,
  Sparkles,
  Star,
  TriangleAlert,
  Undo2,
  Unlink,
  UserRound,
  UserRoundX,
  Wallet,
  WalletMinimal,
  type LucideIcon,
} from 'lucide-react';

/** DESIGN.md §7: outline icons, 18px, stroke 1.75. */
export const ICON_SIZE = 18;
export const ICON_STROKE = 1.75;

/**
 * Lucide names used by the shared label tables (`StatusLabel.icon`) mapped to components.
 * Imported explicitly so unused icons are tree-shaken. Add names with `registerIcons`.
 */
const ICONS = new Map<string, LucideIcon>([
  ['archive', Archive],
  ['badge-check', BadgeCheck],
  ['ban', Ban],
  ['calendar-clock', CalendarClock],
  ['check', Check],
  ['check-check', CheckCheck],
  ['copy-check', CopyCheck],
  ['circle-check', CircleCheck],
  ['circle-help', CircleHelp],
  ['circle-plus', CirclePlus],
  ['circle-slash', CircleSlash],
  ['circle-x', CircleX],
  ['eye', Eye],
  ['file-clock', FileClock],
  ['file-pen', FilePen],
  ['flag', Flag],
  ['hourglass', Hourglass],
  ['file-text', FileText],
  ['file-x', FileX],
  ['inbox', Inbox],
  ['link', Link],
  ['message-circle', MessageCircle],
  ['info', Info],
  ['layers', Layers],
  ['list-ordered', ListOrdered],
  ['list-plus', ListPlus],
  ['loader', LoaderCircle],
  ['log-out', LogOut],
  ['message-circle-reply', MessageCircleReply],
  ['pause', Pause],
  ['rotate-cw', RotateCw],
  ['send', Send],
  ['shield-check', ShieldCheck],
  ['shield-x', ShieldX],
  ['sliders-horizontal', SlidersHorizontal],
  ['skip-forward', SkipForward],
  ['sparkles', Sparkles],
  ['star', Star],
  ['triangle-alert', TriangleAlert],
  ['undo-2', Undo2],
  ['unlink', Unlink],
  ['user-round', UserRound],
  ['user-round-x', UserRoundX],
  ['wallet', Wallet],
  ['wallet-minimal', WalletMinimal],
]);

export function iconByName(name: string | null | undefined, fallback: LucideIcon = Info): LucideIcon {
  return (name && ICONS.get(name)) || fallback;
}

export function registerIcons(entries: Record<string, LucideIcon>): void {
  for (const [name, icon] of Object.entries(entries)) ICONS.set(name, icon);
}
